<template>
  <div class="order_detail">
    <div class="card">
      <div class="title">申请售后</div>
      <div class="base">
        <div class="header">
          <div class="left">
            <div class="name">{{title}}</div>
            <div class="status">状态：<span class="error">{{status_name}}</span></div>
          </div>
          <div class="right">
            <!--            <Button type="primary" size="small">修改订单</Button>-->
            <Button class="cancel" size="small" v-if="status < 4" @click="cancel()">取消订单</Button>
          </div>
        </div>
        <div class="info">
          <span>客户：{{nickname}}</span>
          <span>订单编号：{{order_no}}</span>
          <span>下单时间：{{created_at}}</span>
          <span v-if="end_date != ''">支付截止时间：{{end_date}}</span>
        </div>
      </div>
    </div>
    <div class="block"></div>

    <div class="btn-grounp" style="padding: 20px;">
      <Form class="form" label-position="top">

        <FormItem label="退款">
          <RadioGroup v-model="formItem.type" @on-change="changeHandler">
            <Radio label="1">全部退款</Radio>
            <Radio label="2">部分退款</Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="金额">
          <InputNumber style="width: 150px;margin-left: 15px;height: 32px;" class="text-center" controls-outside
            :min="0" :max="maxRefundMoney" v-model="formItem.money" @on-change="changeMoney"></InputNumber>
          <span class="refund-money-tip">最多可退￥{{ maxRefundMoney }}</span>
        </FormItem>

        <FormItem label="售后说明">
          <Input v-model="formItem.resson" maxlength="200" type="textarea" :autosize="{minRows: 3,maxRows: 6}"
            placeholder="请输入"></Input>
        </FormItem>

        <FormItem label="图片:">
          <Upload :max='5' :more.sync=img_more :imgList.sync="formItem.img"></Upload>
          <div class="tips">最多可上传5张图片</div>
        </FormItem>

        <div class="footer">
          <Button class="pay-btn" type="primary" @click="payment()" style="width: 100px">立即提交</Button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import HeaderComponents from '../../../components/header'
import MasterItem from './components/master-item'
import cancelOrder from '../../../components/cancel-order'
import tabNav from '../../../components/tabNav'
import Upload from '../../../components/upload'

export default {
  name: 'order_detail',
  components: {
    HeaderComponents,
    MasterItem,
    tabNav,
    Upload
  },

  activated () {
    let vm = this
    let id = this.$route.params.id
    vm.id = id
    console.log(id)
    this.$request('6120ad9af2b9b', {
      order_id: id
    }).then(res => {
      console.log(res)
      vm.order_no = res.data.data.base.number
      vm.nickname = res.data.data.base.nickname
      vm.created_at = res.data.data.base.created_at
      vm.status_name = res.data.data.msg
      vm.initial_price = res.data.data.initial_price
      vm.price = res.data.data.price
      vm.status = res.data.data.status

      if (res.data.data.end_date != '' && res.data.data.end_date != undefined && res.data.data.end_date != null) {
        vm.end_date = res.data.data.end_date
      }

      vm.order_type = res.data.data.order_type
      vm.title = res.data.data.title

      vm.address.name = res.data.data.address.name
      vm.address.address = res.data.data.address.address
      vm.address.floor = res.data.data.address.floor
      vm.address.phone = res.data.data.address.phone
      vm.address.third = res.data.data.third

      vm.other.contact = res.data.data.other.contact
      vm.other.hope_complete = res.data.data.other.hope_complete

      if (res.data.data.logistics != null && res.data.data.logistics != undefined && res.data.data.logistics !=
          '') {
        vm.logistics.address = res.data.data.logistics.address
        vm.logistics.arrive = res.data.data.logistics.arrive
        vm.logistics.freight = res.data.data.logistics.freight
        vm.logistics.logistics_number = res.data.data.logistics.logistics_number
        vm.logistics.package_number = res.data.data.logistics.package_number
        vm.logistics.company = res.data.data.logistics.company
        vm.logistics.phone = res.data.data.logistics.phone
        vm.logistics.has = true
      } else {
        vm.logistics.has = false
      }

      if (res.data.data.worker != null && res.data.data.worker != undefined && res.data.data.worker != '') {
        vm.worker_id = res.data.data.worker.worker_id
      }

      if (vm.order_type == 1) {
        this.$request('612349bfeff78', {
          order_id: id,
          page: 1,
          size: 100000
        }).then(res => {
          vm.offer_all = res.data.data.count
          vm.offer_data = res.data.data.list

          console.log(res)
        })
      }
    })
  },
  data () {
    return {
      img_more: true,
      formItem: {
        type: '2',
        resson: '',
        money: '',
        img: []
      },
      payTypeList: [{
        value: 'balance',
        label: '余额支付'
      },
      {
        value: 'wechatpc',
        label: '微信支付'
      }
      ],
      step: 1,
      timer: null,
      order_type: 1,
      id: 0,
      worker_id: 0,
      initial_price: 0,
      price: 0,
      offer_data: [],
      offer_all: 0,
      order_no: '',
      status_name: '',
      end_date: '',
      status: 0,
      nickname: '',
      title: '',
      created_at: '',
      logistics: {
        has: true,
        address: '',
        arrive: '',
        freight: 0,
        logistics_number: '',
        package_number: '',
        phone: '',
        company: ''
      },
      other: {
        contact: '',
        hope_complete: ''
      },
      address: {
        name: '',
        address: '',
        floor: '',
        phone: '',
        third: ''
      },
      columns: [{
        title: '商品图片',
        key: 'name',
        render: (h, parms) => {
          return h('img', {
            attrs: {
              src: 'https://iknow-pic.cdn.bcebos.com/810a19d8bc3eb135a9168029b41ea8d3fc1f444a?x-bce-process=image/quality,q_80'
            },
            style: {
              width: '60px',
              margin: '10px 0'
            }
          })
        }
      },
      {
        title: '安装环境图',
        key: 'age',
        render: (h, parms) => {
          return h('img', {
            attrs: {
              src: 'https://iknow-pic.cdn.bcebos.com/810a19d8bc3eb135a9168029b41ea8d3fc1f444a?x-bce-process=image/quality,q_80'
            },
            style: {
              width: '60px',
              margin: '10px 0'
            }
          })
        }
      },
      {
        title: '商品类别/型号',
        render: (h, parms) => {
          return h('div', {
            style: {
              textAlign: 'center'
            }
          }, [
            h('div', parms.row.type),
            h('div', parms.row.category)
          ])
        }
      },
      {
        title: '商品数量',
        key: 'count'
      },
      {
        title: '商品属性',
        key: 'sku_name'
      },
      {
        title: '特殊要求',
        key: 'requirement'
      },
      {
        title: '安装要求',
        align: 'right',
        tooltip: true,
        key: 'install'
      }
      ],
      data: [{
        img: '',
        type: 'AM12312312',
        category: '盖板/普通',
        count: 1,
        sku_name: '嵌入式（壁挂）',
        requirement: '不要敲门',
        install: '需要拆除（玻璃胶）'
      }]
    }
  },
  computed: {
    maxRefundMoney () {
      const money = parseFloat(this.price)
      return Number.isNaN(money) ? 0 : money
    }
  },
  methods: {
    cancel () {
      let vm = this
      this.$cancelOrder({
        id: vm.id
      }).then(res => {
        console.log(res)
        if (res == 'confirm') {
          console.log('----')
          vm.$message.success('操作成功')
          location.reload()
        }
      })
    },
    changeHandler (value) {
      if (value == 1) {
        this.formItem.money = this.maxRefundMoney
      } else {
        this.formItem.money = ''
      }
    },
    changeMoney (value) {
      if (value > this.maxRefundMoney) {
        this.formItem.money = this.maxRefundMoney
      }
    },
    payment () {
      let vm = this
      if (vm.formItem.money <= 0) {
        return this.$message.error('请输入正确的金额')
      }
      if (vm.formItem.money > vm.maxRefundMoney) {
        return this.$message.error('退款金额不能超过订单金额')
      }
      if ((vm.formItem.money + '').split('.') && (vm.formItem.money + '').split('.')[1] && (vm.formItem.money + '').split('.')[1].length > 2) {
        return this.$message.error('请输入正确的金额')
      }
      if (!vm.formItem.resson) {
        return this.$message.error('请输入售后说明')
      }

      this.$util.throttle(() => {
        this.$request('614aea37c5d80', {
          'order_id': vm.id,
          'type': parseInt(vm.formItem.type),
          'money': vm.formItem.money.toString(),
          'resson': vm.formItem.resson,
          'img': vm.formItem.img
        }).then(res => {
          this.$message.success('提交成功')
          location.reload()
        })
      }, 2000, true)
    },
    gotoPay () {
      console.log('gotoPay')
    }
  }
}
</script>

<style lang="less">
  .order_detail {

    .ivu-steps-title {
      margin-top: 2px;
    }

    .card {
      background-color: #FFFFFF;
      padding: 20px;
      border-radius: 3px;

      .base {
        margin-top: 30px;
        border-radius: 3px;

        .header {
          display: flex;
          justify-content: space-between;

          .left {
            display: flex;
          }

          .status {
            margin-left: 30px;

            .error {
              color: red;
            }
          }

          .right .cancel {
            margin-left: 10px;
          }
        }

        .info {
          margin-top: 10px;

          span {
            margin-right: 40px;
          }
        }
      }

      .title {
        font-size: 18px;
        color: #333;
        font-weight: 450;
        position: relative;

        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          left: 0;
          width: 70px;
          height: 3px;
          background-color: #FB9E2F;
        }
      }

    }

    .block {
      height: 10px;
      background-color: #f7f8fa;
    }

    .step {
      padding: 20px;

      .title {
        margin-bottom: 15px;
        color: rgb(51, 51, 51);
        font-size: 18px;
        margin-right: 12px;
      }
    }

    .user-info {
      padding: 20px;
    }

    .descriptions-label {
      color: #333333;
    }

    .el-descriptions__title {
      color: rgb(51, 51, 51);
      font-size: 18px;
      font-weight: normal;
    }

    .error {
      color: red;
    }
  }
 .ivu-input-number-input-wrap{
	  height: 32px !important;
  }
  .ivu-input-number-input{
	  height: 32px !important;
	  line-height: 32px !important;
	  position: relative;
	  top: -5px;
  }
  .refund-money-tip {
    margin-left: 12px;
    color: #999;
    font-size: 13px;
  }
</style>
